import Header from "components/Header/Header";

const SiteHeader = () => {

  return <Header />;
};

export default SiteHeader;
